export const podcastsData = [
  {
    id: 1,
    title: "Podcast With Real Hacker Abhishek Parashar",
    thumbnail: "https://img.youtube.com/vi/cDxIyynl2yw/maxresdefault.jpg",
    url: "https://youtu.be/cDxIyynl2yw?si=cFgBaJfHks4jO35q",
    platform: "YouTube"
  },
  {
    id: 2,
    title: "EXPOSED India's Top Cybercrime Cases",
    description: "YTMahendra Podcast",
    thumbnail: "https://img.youtube.com/vi/dMZPOA6HO-A/maxresdefault.jpg",
    url: "https://youtu.be/dMZPOA6HO-A?si=HWbz4fe5vXz5h6Ao",
    platform: "YouTube"
  },
  {
    id: 3,
    title: "Cybersecurity Secrets EXPOSED!",
    description: "Shallu Nisha Podcast",
    thumbnail: "https://img.youtube.com/vi/rF_Gz2iPLao/maxresdefault.jpg",
    url: "https://www.youtube.com/watch?v=rF_Gz2iPLao",
    platform: "YouTube"
  },
  {
    id: 4,
    title: "Cybersecurity Roadmap as Plan B",
    description: "How to Become Ethical Hacker in 2025? 🚀",
    thumbnail: "https://img.youtube.com/vi/5z91ZUyvDO4/maxresdefault.jpg",
    url: "https://youtu.be/5z91ZUyvDO4?si=k3HJs5nylOxVnzkY",
    platform: "YouTube"
  },
  {
    id: 5,
    title: "Darkest Reality Of Social Media 😱",
    description: "Social Media Dark Faces 💀",
    thumbnail: "https://img.youtube.com/vi/z40_CSCYoXc/maxresdefault.jpg",
    url: "https://youtu.be/z40_CSCYoXc?si=7pG-VbOUmu-iWyYf",
    platform: "YouTube"
  },
  {
    id: 6,
    title: "Interview with Cyber Expert",
    description: "आपका iPhone भी सेफ नहीं? | Dilli24 News",
    thumbnail: "https://img.youtube.com/vi/JYUCDLRQ7ko/maxresdefault.jpg",
    url: "https://youtu.be/JYUCDLRQ7ko?si=wR7Co8yn9pHnX62h",
    platform: "YouTube"
  }
];

export const mediaCoverageData = [
  {
    id: 1,
    title: "Guest Speaker at Lords University",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/4nnkybc5_image.png",
    source: "Lords University",
    date: "Feb 2025",
    category: "Academic"
  },
  {
    id: 2,
    title: "Featured in Business Newspaper for Social Impact",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/ri8qmcv6_image.png",
    source: "Business Newspaper",
    date: "2024",
    category: "Press"
  },
  {
    id: 3,
    title: "Collaborating with Cyber Cells",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/a4snulz4_image.png",
    source: "Police Cyber Cell",
    date: "2024",
    category: "Law Enforcement"
  },
  {
    id: 4,
    title: "Guest Speaker at NSUT Delhi",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/p3k7pn6g_image.png",
    source: "NSUT Delhi",
    date: "2024",
    category: "Academic"
  },
  {
    id: 5,
    title: "Deepfakes, Not so Fake - Expert Commentary",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/hp8unuab_image.png",
    source: "Deccan Chronicle",
    date: "Aug 2024",
    category: "Press"
  },
  {
    id: 6,
    title: "Hands-On Ethical Hacking Training - Offline Classes",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/d634p3vd_image.png",
    source: "Indian Cyber Club",
    date: "2024",
    category: "Training"
  },
  {
    id: 7,
    title: "Digi Arrest Fear Grips the Nation - Expert Analysis",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/xr2ialuo_image.png",
    source: "Deccan Chronicle",
    date: "Nov 2024",
    category: "Press"
  },
  {
    id: 8,
    title: "Featured in National Media Coverage",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/cw9lo5ht_image.png",
    source: "Press Coverage",
    date: "2024",
    category: "Press"
  },
  {
    id: 9,
    title: "Guest Speaker - Cybersecurity Workshop",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/mpshf3nm_image.png",
    source: "Educational Institution",
    date: "2025",
    category: "Academic"
  },
  {
    id: 10,
    title: "Working with Cyber Cells",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/tqndkecb_WhatsApp%20Image%202026-01-27%20at%202.31.08%20PM.jpeg",
    source: "Police Cyber Cell Collaboration",
    date: "2024",
    category: "Law Enforcement"
  },
  {
    id: 11,
    title: "Cybersecurity Awareness Initiative",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/yt8kevsr_WhatsApp%20Image%202026-01-27%20at%202.31.07%20PM.jpeg",
    source: "Community Outreach",
    date: "2024",
    category: "Awareness"
  },
  {
    id: 12,
    title: "Advanced Penetration Testing Workshop",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/zkzbsvdk_IMG_20260127_145308.jpg.jpeg",
    source: "ICC Training Center",
    date: "2025",
    category: "Training"
  },
  {
    id: 13,
    title: "Ethical Hacking Masterclass - Live Training",
    image: "https://customer-assets.emergentagent.com/job_enroll-links-add/artifacts/bqyh2ene_IMG_20260127_145807.jpg.jpeg",
    source: "ICC Training Center",
    date: "2025",
    category: "Training"
  }
];
